export const centerActivityConstants = {
  ACTIVITY_DATA: "ACTIVITY_DATA",
  ACTIVITY_DATA_BY_ID: "ACTIVITY_DATA_BY_ID",
  VIEW_MODAL: "VIEW_MODAL",
  ADD_CENTER_ACTIVITY: "ADD_CENTER_ACTIVITY",
  PUBLISH_CENTER_ACTIVITY: "PUBLISH_CENTER_ACTIVITY",
  UPDATE_CENTER_ACTIVITY: "UPDATE_CENTER_ACTIVITY",
  UPDATE_CENTER_ACTIVITY_BY_ID: "UPDATE_CENTER_ACTIVITY_BY_ID",
  DELETE_CENTER_ACTIVITY: "DELETE_CENTER_ACTIVITY",
  
  PUBLISH_BUTTON: "PUBLISH_BUTTON",
  UNPUBLISH_BUTTON: "UNPUBLISH_BUTTON",
  UPDATE_BUTTON: "UPDATE_BUTTON",
  DRAFT_BUTTON: "DRAFT_BUTTON",
  ADD_BUTTON: "ADD_BUTTON",
  CALENDER_DATA: "CALENDER_DATA",

};

export const centerActivityStatusEnum = {
  PUBLISHED: 0,
  UNPUBLISHED: 1,
  DRAFT: 2,
  EXPIRED: 3,
};
